import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { buildSeoProductString } from 'helpers/SeoUrlBuilder';
import { trackLegacyEvent } from 'helpers/analytics';
import { fetchProductDetail, setCarouselIndex } from 'actions/productDetail';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import ImageCarousel from 'components/common/ImageCarousel';
import { Clear } from 'components/icons';
import { Loader } from 'components/Loader';
import { constructMSAImageUrl } from 'helpers';
import ProductUtils from 'helpers/ProductUtils';
import css from 'styles/containers/productImage.scss';

// Top level container for route that shows full page images on mobile (equivalent to desktop "easy zoom")
export class ProductImage extends Component {

  componentDidMount() {
    const { product: { detail }, params: { productId, index }, setCarouselIndex } = this.props;
    setCarouselIndex(+index);
    if (!detail || !detail.productId || detail.productId !== productId) {
      this.getImages();
    }
  }

  componentWillUnmount() {
    trackLegacyEvent('Product-Page', 'Zoom-Out', 'Close-Click');
  }

  // TODO this should probably just be a link for a11y reasons (See #3839)
  onBackButtonClick = () => {
    const { params: { colorId, productId }, product: { detail } } = this.props;
    const seoName = buildSeoProductString(detail, colorId);
    this.context.router.push(`/p/${seoName}/product/${productId}${colorId ? `/color/${colorId}` : ''}`);
  };

  getImageList = () => {
    const {
      product: { detail: { styles } },
      params: { styleId }
    } = this.props;
    if (styles.length) {
      const style = ProductUtils.getStyleMap(styles)[styleId];
      if (style && style.images) {
        return style.images.map(m => constructMSAImageUrl(m.imageId, { width: 960 }));
      }
    }
    return [];
  };

  getImages = () => {
    const { params: { colorId, productId }, fetchProductDetail } = this.props;
    fetchProductDetail(productId, { includeRecos: false, colorId, seoName: '', firePixel: true });
  };

  afterSlide = index => {
    const { params: { productId, colorId, styleId }, setCarouselIndex } = this.props;
    setCarouselIndex(index);
    this.context.router.replace(`/i/${productId}${colorId ? `/color/${colorId}` : ''}/style/${styleId}/${index}`);
  };
  makeImages = () => {
    const { testId } = this.context;
    const { params: { index } } = this.props;
    const convertedImages = this.getImageList();
    const imageIndex = parseInt(index, 10);
    return (
      <ImageCarousel
        slidesToScroll={1}
        slidesToShow={1}
        autoplay={false}
        wrapAround={true}
        slideIndex={imageIndex}
        afterSlide={this.afterSlide}>
        {convertedImages.map((image, index) =>
          <img
            src={image}
            alt={index}
            key={index}
            data-test-id={testId('mobileProductImage')}/>)}
      </ImageCarousel>
    );
  };

  render() {
    const { product } = this.props;
    const { testId } = this.context;
    return (
      <SiteAwareMetadata>
        {product && product.detail && product.detail.styles
          ? (
            <div className={css.productImage}>
              <button
                type="button"
                className={css.clear}
                onClick={this.onBackButtonClick}
                data-test-id={testId('productImageZoomClose')}>
                <Clear size={35}/>
              </button>
              {this.makeImages()}
            </div>
          )
          : <Loader/>
        }
      </SiteAwareMetadata>
    );
  }
}

ProductImage.contextTypes = {
  router: PropTypes.object.isRequired,
  testId: PropTypes.func
};

const mapStateToProps = state => ({ product: state.product });

export default connect(mapStateToProps, {
  fetchProductDetail,
  setCarouselIndex
})(ProductImage);
